// extracted by mini-css-extract-plugin
module.exports = {"section":"K_section__ofSu0"};